import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  scheduleFreightTitle: {
    defaultMessage: 'Schedule Freight',
    id: 'e4nwH8',
    description: 'Title of the Schedule Freight step',
  },
  customerFullNameLabel: {
    defaultMessage: 'Full name',
    id: 'VoBcnP',
    description: 'Label for customer full name input',
  },
  emailLabel: {
    defaultMessage: 'Email address',
    id: 'Im27cF',
    description: 'Label for email input',
  },
  phoneNumberLabel: {
    defaultMessage: 'Phone number',
    id: 'OQ7L0c',
    description: 'Label for phone number input',
  },
  scheduleFreightInstructions: {
    defaultMessage:
      'After arranging freight for this advance shipping notice, please provide the contact details and preferred delivery times. Our warehouse will confirm your delivery appointment within 1-2 business days.',
    id: 'Z/V7dk',
    description: 'Instructions for the schedule freight step',
  },
  customerContactDetails: {
    defaultMessage: 'Your Contact Details',
    id: 'trS+6v',
    description: 'Title for the customer contact details section',
  },
  carrierContactDetails: {
    defaultMessage: 'Carrier Contact Details',
    id: 'HsXHP4',
    description: 'Title for the carrier contact details section',
  },
  carrierFullNameLabel: {
    defaultMessage: 'Carrier name',
    id: 'w3lLMd',
    description: 'Label for carrier name input',
  },
  deliveryNotesLabel: {
    defaultMessage: 'Delivery notes (optional)',
    id: 'CqEGyf',
    description: 'Label for delivery notes input',
  },
  dropOffTimeSlotLabel: {
    defaultMessage: 'Request Drop-Off Appointment',
    id: '4LNM2b',
    description: 'Label for drop off time slot inputs',
  },
  dropOffTimeSlotInstructions: {
    defaultMessage:
      'Specify three dates and times your carrier can drop off your freight shipment. Freight can be delivered M–F from 8am to 3:30pm local time. If you know the date but are unsure of the time, select three times on your delivery date.',
    id: 'Oc5vNt',
    description: 'Instructions for drop off time slot input',
  },
  dropOffTimeSlotInfo: {
    defaultMessage: 'Drop-offs must be scheduled with at least 72 hours notice and are only accepted on business days.',
    id: 'Ki/ymL',
    description: 'Info message for drop off time slot input',
  },
  dropOffDateLabel: {
    defaultMessage: 'Enter date',
    id: 'gJLU8n',
    description: 'Label for drop off date input',
  },
  dropOffTimeLabel: {
    defaultMessage: 'Select time',
    id: 'tX/bw9',
    description: 'Label for drop off time input',
  },
  dropOffDateLabel1: {
    defaultMessage: 'Submitted Drop-off Date #1',
    id: 'QCWo2J',
    description: 'Label for drop off date input',
  },
  dropOffDateLabel2: {
    defaultMessage: 'Submitted Drop-off Date #2',
    id: '4UfY4B',
    description: 'Label for drop off date input',
  },
  dropOffDateLabel3: {
    defaultMessage: 'Submitted Drop-off Date #3',
    id: 'F7aQ6q',
    description: 'Label for drop off date input',
  },
  requiredError: {
    defaultMessage: 'Required',
    id: 'SfY3+i',
    description: 'Error message for required fields',
  },
  submitButton: {
    defaultMessage: 'Submit',
    id: 'Cyq8xJ',
    description: 'Label for the submit button',
  },
  invalidEmail: {
    defaultMessage: 'Enter a valid email address',
    id: 'ZeJHxv',
    description: 'Error messaging to inform user their email address they input is invalid',
  },
});
